<template>
<!--  违章整改-->
<div style="width:100%;padding-top: 60px">
  <div style="position: fixed;top: 0px;z-index: 999;width: 100%;">
    <div style="text-align:center">
      <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">办理</van-button>
      <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
    </div>

    <div class="doTask" v-if="isshow">
      <div>
        <van-field name="radio" label="审批意见">
          <template #input>
            <van-radio-group v-model="auditForm.status" direction="horizontal">
              <van-radio name="同意">同意</van-radio>
              <van-radio name="不同意">不同意</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </div>
      <div>
        <van-cell-group>
          <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
        </van-cell-group>
      </div>
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
      </div>
    </div>
  </div>

  <van-collapse v-model="activeNames">
    <van-collapse-item title="基本信息" name="1">
      <van-field v-model="inputForm.projectName" label="物业项目名称" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.houseName" label="房号" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.applicantName" label="装修申请人" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.applicantPhone" label="联系方式" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.companyName" v-if="inputForm.companyName" label="装修公司" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.companyLiable" v-if="inputForm.companyLiable" label="负责人" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.companyPhone" v-if="inputForm.companyPhone" label="联系方式" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.questionDate" label="签发日期" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.rectifyUserName" label="签发人" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.questionEndDate" label="整改期限" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.questionDesc" label="整改问题描述" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field label="整改问题图片" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea">
<!--        <template #input>-->
<!--          <div style="display: flex;flex-wrap: wrap;">-->
<!--            <img v-for="(item,index) in picArr" :key="index" :src="item" style="width: 100px;height: 100px;margin-right: 10px;">-->
<!--          </div>-->
<!--        </template>-->
      </van-field>
      <div style="display: flex; padding-left: 16px">
        <van-image v-for="(item, index) in picArr" :key="item.id" width="100px" height="100px" fit="cover" :src="item.url" @click="preview(picArr, index)" />
      </div>
<!--      <div style="padding-left: 16px;">-->
<!--        <p>附件</p>-->
<!--        <a class="m-row" style="display: block; color: #4caedc" v-for="file in inputForm.attachList" :href="file.url">{{file.name}}</a>-->
<!--        <div class="m-row" v-if="inputForm.attachList.length==0">无</div>-->
<!--      </div>-->
      <div style="padding-left: 16px;" v-show="inputForm.attachList.length > 0">
        <p>附件</p>
        <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
      </div>
    </van-collapse-item>
    <van-collapse-item title="整改信息" name="2" v-if="this.inputForm.rectifyStatus === '12' || this.inputForm.rectifyStatus === '11'">
      <van-field v-model="inputForm.rectifyDate" label="整改完成时间" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.rectifyResult" label="整改结果" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field label="整改完成图片" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea">
<!--        <template #input>-->
<!--          <div style="display: flex;flex-wrap: wrap;">-->
<!--            <img v-for="(item,index) in picRectifyArr" :key="index" :src="item" style="width: 100px;height: 100px;margin-right: 10px;">-->
<!--          </div>-->
<!--        </template>-->
      </van-field>
      <div style="display: flex; padding-left: 16px">
        <van-image v-for="(item, index) in picRectifyArr" :key="item.id" width="100px" height="100px" fit="cover" :src="item.url" @click="preview(picRectifyArr, index)" />
      </div>
    </van-collapse-item>
  </van-collapse>

  <process-record :procInsId="procInsId"></process-record>
</div>
</template>

<script>
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import {ImagePreview} from "vant";
import processRecord from "../../components/processRecord/processRecord";
export default {
  name: "decorateRectify",
  data(){
    return {
      activeNames: ['1', '2'],
      isshow: false,
      radio: '',
      inputForm:{
        isDoTask: false,
        isLastTask: false,
        projectName:'',
        houseName:'',
        applicantName:'',
        applicantPhone:'',
        companyName:'',
        companyLiable:'',
        companyPhone:'',
        questionDate:'',
        rectifyUserName:'',
        questionEndDate:'',
        questionDesc:'',
        rectifyDate:'',
        rectifyResult:'',
      },
      picArr:[],
      picRectifyArr: [],
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type:'',
    }
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
  },
  components: {
    processRecord
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/decorate/wuyeDecorateRectify/queryById').then(({ data }) => {
        this.inputForm = data
        // 问题图片
        if (this.inputForm.questionPic !== '') {
          this.inputForm.questionPic.split('|').forEach((item) => {
            if (item.trim().length > 0) {
              this.picArr.push({ name: decodeURIComponent(item.substring(item.lastIndexOf('/') + 1)), url: item })
            }
          })
        }
        // 整改图片
        if (this.inputForm.rectifyPic !== '') {
          this.inputForm.rectifyPic.split('|').forEach((item) => {
            if (item.trim().length > 0) {
              this.picRectifyArr.push({
                name: decodeURIComponent(item.substring(item.lastIndexOf('/') + 1)),
                url: item
              })
            }
          })
        }
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(_this.inputForm, '/decorate/wuyeDecorateRectify/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = 3;
          _this.$flow.startFlow(_this.inputForm, '/decorate/wuyeDecorateRectify/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    preview(arr, index){
      ImagePreview({
        images: arr.map(item => item.url),
        startPosition: index
      })
    }
  }
}
</script>

<style scoped>

</style>